
import { defineComponent } from "vue";

export default defineComponent({
  name: "scrollToTop",
  setup() {
    // const btn: any = document.getElementById("btn");
    window.onscroll = () => {
      const btn: any = document.getElementById("btn");
      if (document.documentElement.scrollTop > 100) {
        btn.classList.remove("hidden");
      } else {
        btn.classList.add("hidden");
      }
    };
    return {};
  },
});
